export const NO_IMPORTANCE_SET = 'NO_IMPORTANCE_SET';
